<style>
.last-state {
    font-size: 2rem;
}

.last-state-small {
    font-size: 1.3rem;
    color: #bdc3c7;
}
</style>

<template>
<div>
	<div class="vx-col w-full mb-base">
		<vs-card title="Inbound Details" class="p-4 mb-6">
         <div slot="header" class="flex flex-wrap items-center justify-between">
        	<div class="flex items-center">
	            <vs-button radius color="primary" icon="keyboard_backspace" @click="cancelAndBack()"></vs-button>
	        	<h4 class="ml-5">Item Check</h4>
            </div>
            <div class="flex items-center" >
          <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editInbound" v-show="!on_edit">Edit Inbound</vs-button> -->
          <!-- <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="saveItemCheck">Save</vs-button> -->
            </div>
        </div>
		  	<div class="vx-row mt-6">
		    <div class="vx-col md:w-1/4 w-full">
				<div class="vx-row mb-3">
				    <div class="vx-col w-full">
				      <vs-input class="w-full" label="ID" v-model="gr_id" disabled/>
				    </div>
				  </div>
				  <div class="vx-row mb-3">
				    <div class="vx-col w-full">
				      <vs-input class="w-full" label="GR Reference" v-model="gr_reference"  :disabled="true" />
				    </div>
				  </div>
		    </div>
		    <div class="vx-col md:w-1/4 w-full">
				 <div class="vx-row mb-3">
				    <div class="vx-col w-full">
				      <vs-input class="w-full" label="GR Status" v-model="gr_status" disabled />
				    </div>
				  </div>
		    </div>
	  		</div>
			  <vs-tabs class="mt-10">
				  <vs-tab label="Outstanding">
					<vs-button class="btn mb-5 mr-1 mt-5" @click="storeAll">Save</vs-button>
					<vs-button class="btn mb-5 mr-1 mt-5" @click="refresh">Refresh</vs-button>
					<vs-button class="btn mb-5 mr-1 mt-5" @click="checkInit">Check</vs-button>
					  <div style="overflow-y: auto;">
							<vs-table stripe :data="gr_details" v-model="gr_details_selected" multiple pagination max-items="10" search>
								<template slot="thead">
									<vs-th>Line ID</vs-th>
									<vs-th>Product</vs-th>
									<vs-th>Description</vs-th>
									<vs-th>Pack ID</vs-th>
									<vs-th>Batch</vs-th>
									<vs-th>Exp. Date</vs-th>
									<vs-th>Qty</vs-th>
									<vs-th>UoM</vs-th>
									<vs-th>Stock Type</vs-th>
									<vs-th>Base Qty</vs-th>
									<vs-th>Base UoM</vs-th>
									<vs-th>Actions</vs-th>
								</template>

								<template slot-scope="{data}">
									<vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr" :v-show="tr.status !== 'delete'">
									<vs-td>
										{{indextr+1}}
									</vs-td>

									<vs-td>
										{{data[indextr].product_code}}
									</vs-td>


									<vs-td>
										{{data[indextr].description}}
									</vs-td>

									<vs-td>
										<vs-input class="w-full" v-model="data[indextr].pack_id"/>
									</vs-td>

									<vs-td>
										<vs-input class="w-full" v-model="data[indextr].batch"/>
									</vs-td>

									<vs-td>
										<flat-pickr class="w-full" v-model="data[indextr].expired_date"/>
									</vs-td>

									<vs-td>
										<vs-input class="w-full" v-model="data[indextr].qty" disabled/>
									</vs-td>

									<vs-td>
										<vs-select
											class="selectExample"
											v-model="data[indextr].uom_id"
											width="100%"
											autocomplete
										>
											<vs-select-item v-for="(item, index) in data[indextr].uom_options" :key="index" :value="item.id" :text="item.name"/>
										</vs-select>
									</vs-td>

									<vs-td>
										<vs-select
											class="selectExample"
											v-model="data[indextr].stock_type_id"
											width="100%"
											autocomplete
										>
											<vs-select-item v-for="(item, index) in stocktypesOption" :key="index" :value="item.id" :text="item.name"/>
										</vs-select>
									</vs-td>

									<vs-td>
										{{data[indextr].base_qty}}
									</vs-td>

									<vs-td>
										{{data[indextr].base_uom_name}}
									</vs-td>
									<vs-td>
										<vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="viewProduct(data[indextr], indextr)">Split</vs-button>
									</vs-td>

									</vs-tr>
								</template>
							</vs-table>
						</div>
				  </vs-tab>
				  <vs-tab label="Checked Items">
						<vs-button class="btn mb-5 mr-1 mt-5" @click="cancelAll">Cancel Check</vs-button>
					<vs-button class="btn mb-5 mr-1 mt-5" @click="refresh">Refresh</vs-button>
					  <vs-table stripe multiple :data="gr_checked" v-model="gr_checked_selected" pagination max-items="20" hoverFlat search>
						      <template slot="thead">
						        <vs-th>Product</vs-th>
						        <vs-th>Description</vs-th>
						        <vs-th>Remark</vs-th>
						        <vs-th>Pack ID</vs-th>
						        <vs-th>Batch</vs-th>
						        <vs-th>Exp. Date</vs-th>
						        <vs-th>Qty</vs-th>
						        <vs-th>UoM</vs-th>
						        <vs-th>Stock Type</vs-th>
						        <vs-th>Base Qty</vs-th>
						        <vs-th>Base UoM</vs-th>
						      </template>

						      <template slot-scope="{data}">
						        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
						          <vs-td>
						            {{data[indextr].product_code}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].description}}
						          </vs-td>

								  <vs-td>
						            {{data[indextr].item_remark}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].pack_id}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].batch}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].expired_date}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].uom_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].stock_type_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_base_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].base_uom_name}}
						          </vs-td>


						        </vs-tr>
						      </template>
					    </vs-table>
				  </vs-tab>
			  </vs-tabs>
		</vs-card>

		<vs-popup title="Check Items" :active.sync="checkPopup" fullscreen>
        	<vs-tabs alignment="center">
        		<vs-tab label="Add Item" @click="batchCheck.product_code = ''; focusInput('product_code', true, 300)">
			      	<div class="vx-row">
			      		<div class="vx-col md:w-1/3">
					    	<div class="vx-row mb-3">
						    	<div class="vx-col w-full">
							        <vs-input class="w-full" label="Product Code" v-model="batchCheck.product_code" @keyup.enter="getCheckingProduct" ref="product_code" size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Description" v-model="batchCheck.description" disabled size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Pack ID" v-model="batchCheck.pack_id" @keyup.enter="batchScan" ref="pack_id" size="large"/>
							    </div>
							</div>
			      		</div>
			      		<div class="vx-col md:w-1/3">
						  <div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Batch" v-model="batchCheck.batch" size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      <label for="" class="vs-input--label">Expired Date</label>
							      <flat-pickr class="w-full" v-model="batchCheck.expired_date" style="font-size: 1.2rem; padding: 1rem"/>
							    </div>
						    </div>
							<div class="vx-row mb-3">
							    <div class="vx-col md:w-1/2 w-full">
							        <vs-input class="w-full" label="UoM" v-model="batchCheck.uom" size="large"/>
							    </div>
							    <div class="vx-col md:w-1/2 w-full">
							        <vs-input class="w-full" label="Qty" v-model="batchCheck.qty" @keyup.enter="batchScan" size="large"/>
							    </div>
							</div>
			      		</div>
			      		<div class="vx-col md:w-1/3">
						  <div class="vx-row mb-3">
							    <div class="vx-col w-full">
									<vs-input class="w-full" label="Stock Type" v-model="batchCheck.stock_type" size="large"/>
							    </div>
							</div>
						    <div class="vx-row mb-3">
							    <div class="vx-col w-full">
							       <vs-input class="w-full" label="Open Qty" v-model="batchCheck.out_standing_base_qty" :disabled="true" size="large"/>
							    </div>
							</div>
			      			<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      	<label for="" class="vs-input--label">Remarks</label>
							      	<vs-textarea v-model="batchCheck.remark" style="font-size: 1.2rem;"/>
							    </div>
							</div>
						    <p class="my-4 text-right">
						    	<vs-button class="mr-2" color="primary" @click="batchScan">Save</vs-button>
						    </p>
			      		</div>
			      	</div>
                    <vs-divider border-style="solid" color="dark"></vs-divider>
                    <div class="vx-row mb-3 mt-5">
                        <div class="vx-col w-1/2 last-state text-left pr-10">
                            Current Product
                            <div v-show="currentProduct.product_code">
                                <br>
                                {{ currentProduct.product_code }}
                                <br>
                                {{ currentProduct.description }}
                                <br>
                                Base Qty: {{ currentProduct.base_uom }}
                                <br>
                                Outstanding Qty: {{ currentProduct.outstanding_qty }}
                            </div>
                        </div>
                        <div class="vx-col w-1/2 last-state-small text-right pr-10">
                            Last Scanned Product
                            <br>
                            <br>
                            {{ lastScanned.product_code }}
                            <br v-if="lastScanned.pack_id">
                            <span v-show="lastScanned.pack_id"> Pack ID: {{ lastScanned.pack_id }}</span>
                            <br>
                            {{ lastScanned.description }}
                            <br>
                            {{ lastScanned.qty }}
                        </div>
                    </div>
        		</vs-tab>

				<vs-tab label="Add Document" v-if="client_doc" @click="documentCheck.product_code = ''; focusInput('product_code', true, 300)">
			      	<div class="vx-row">
			      		<div class="vx-col md:w-1/3">
					    	<div class="vx-row mb-3">
						    	<div class="vx-col w-full">
							        <vs-input class="w-full" label="Product Code" v-model="documentCheck.product_code" @keyup.enter="getCheckingProductDoc" ref="product_code" size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Description" v-model="documentCheck.description" disabled size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Pack ID" v-model="documentCheck.pack_id" @keyup.enter="batchScanDoc" ref="pack_id" size="large"/>
							    </div>
							</div>
			      		</div>
			      		<div class="vx-col md:w-1/3">
						  <div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Batch" v-model="documentCheck.batch" size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      <label for="" class="vs-input--label">Expired Date</label>
							      <flat-pickr class="w-full" v-model="documentCheck.expired_date" style="font-size: 1.2rem; padding: 1rem"/>
							    </div>
						    </div>
							<div class="vx-row mb-3">
							    <div class="vx-col md:w-1/2 w-full">
							        <vs-input class="w-full" label="UoM" v-model="documentCheck.uom" size="large"/>
							    </div>
							    <div class="vx-col md:w-1/2 w-full">
							        <vs-input class="w-full" label="Qty" v-model="documentCheck.qty" @keyup.enter="batchScanDoc" size="large"/>
							    </div>
							</div>
			      		</div>
			      		<div class="vx-col md:w-1/3">
						  <div class="vx-row mb-3">
							    <div class="vx-col w-full">
									<vs-input class="w-full" label="Stock Type" v-model="documentCheck.stock_type" size="large"/>
							    </div>
							</div>
						    <div class="vx-row mb-3">
							    <div class="vx-col w-full">
							       <vs-input class="w-full" label="Open Qty" v-model="documentCheck.out_standing_base_qty" :disabled="true" size="large"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      	<label for="" class="vs-input--label">Remarks</label>
							      	<vs-textarea rows="8" v-model="documentCheck.remark" style="font-size: 1.2rem;" ref="remark_doc"/>
							    </div>
							</div>
						    <p class="my-4 text-right">
						    	<vs-button class="mr-2" color="primary" @click="batchScanDoc">Save</vs-button>
						    </p>
			      		</div>
			      	</div>
                    <vs-divider border-style="solid" color="dark"></vs-divider>
                    <div class="vx-row mb-3 mt-5">
                        <div class="vx-col w-1/2 last-state text-left pr-10">
                            Current Product
                            <div v-show="currentProductDoc.product_code">
                                <br>
                                {{ currentProductDoc.product_code }}
                                <br>
                                {{ currentProductDoc.description }}
                                <br>
                                Base Qty: {{ currentProductDoc.base_uom }}
                                <br>
                                Outstanding Qty: {{ currentProductDoc.outstanding_qty }}
                            </div>
                        </div>
                        <div class="vx-col w-1/2 last-state-small text-right pr-10">
                            Last Scanned Product
                            <br>
                            <br>
                            {{ lastScannedDoc.product_code }}
                            <br v-if="lastScannedDoc.pack_id">
                            <span v-show="lastScannedDoc.pack_id"> Pack ID: {{ lastScannedDoc.pack_id }}</span>
                            <br>
                            {{ lastScannedDoc.description }}
                            <br>
                            {{ lastScannedDoc.qty }}
                        </div>
                    </div>
        		</vs-tab>

				<vs-tab label="Checked Items">
                	<div class="flex flex-wrap items-center justify-between my-6">
		                <div class="flex items-right">
			         		 <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="cancelCheck">Cancel Check</vs-button>
		           		</div>
	                </div>
                    <vs-table stripe multiple :data="gr_checked" v-model="selectedCheckedItem" hoverFlat pagination max-items="20" search>
						      <template slot="thead">
						        <vs-th>Product</vs-th>
						        <vs-th>Description</vs-th>
						        <vs-th>Remark</vs-th>
						        <vs-th>Pack ID</vs-th>
						        <vs-th>Batch</vs-th>
						        <vs-th>Exp. Date</vs-th>
						        <vs-th>Qty</vs-th>
						        <vs-th>UoM</vs-th>
						        <vs-th>Stock Type</vs-th>
						        <vs-th>Base Qty</vs-th>
						        <vs-th>Base UoM</vs-th>
						      </template>

						      <template slot-scope="{data}">
						        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
						          <vs-td>
						            {{data[indextr].product_code}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].description}}
						          </vs-td>

								  <vs-td>
						            {{data[indextr].item_remark}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].pack_id}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].batch}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].expired_date}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].uom_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].stock_type_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_base_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].base_uom_name}}
						          </vs-td>


						        </vs-tr>
						      </template>
					    </vs-table>
					</vs-tab>
                    <vs-tab label="Outstanding Items">
                        <vs-table stripe :data="gr_details" hoverFlat pagination max-items="20" search>
						      <template slot="thead">
						        <vs-th>Product</vs-th>
						        <vs-th>Description</vs-th>
						        <vs-th>Pack ID</vs-th>
						        <vs-th>Batch</vs-th>
						        <vs-th>Exp. Date</vs-th>
						        <vs-th>Stock Type</vs-th>
						        <vs-th>Base Qty</vs-th>
						        <vs-th>Base UoM</vs-th>
						      </template>

						      <template slot-scope="{data}">
						        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
						          <vs-td>
						            {{data[indextr].product_code}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].description}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].pack_id}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].batch}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].expired_date}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].stock_type_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].base_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].base_uom_name}}
						          </vs-td>


						        </vs-tr>
						      </template>
					    </vs-table>
					</vs-tab>
        	</vs-tabs>

    	</vs-popup>

        <vs-popup title="Checking Items" :active.sync="showPopup" fullscreen>

        	<vs-tabs alignment="center">
        		<vs-tab label="Add Item">
			      	<div class="vx-row">
			      		<div class="vx-col md:w-1/3">
					    	<div class="vx-row mb-3">
						    	<div class="vx-col w-full">
							        <vs-input class="w-full" label="Product Code" v-model="check.product_code"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Pack ID" v-model="check.pack_id"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							        <vs-input class="w-full" label="Batch" v-model="check.batch" />
							    </div>
							</div>
			      		</div>
			      		<div class="vx-col md:w-1/3">
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      <label for="" class="vs-input--label">Expired Date</label>
							      <flat-pickr class="w-full" v-model="check.expired_date"/>
							    </div>
						    </div>
							<div class="vx-row mb-3">
							    <div class="vx-col md:w-1/2 w-full">
							      	<label for="" class="vs-input--label">UoM</label>
							    	<vs-select
                                        class="selectExample"
                                        v-model="check.uom_id"
                                        width="100%"
                                        autocomplete
                                        @input="onChangeUom(check)"
                                    >
                                    <vs-select-item v-for="(item, index) in check.uomOption" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
							    </div>
							    <div class="vx-col md:w-1/2 w-full">
							        <vs-input class="w-full" label="Qty" v-model="check.qty" :disabled="check.label_type == 'UID'"/>
							    </div>
							</div>
							<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      	<label for="" class="vs-input--label">Stock Types</label>
								    <vs-select
                                        class="selectExample"
                                        v-model="check.stock_type_id"
                                        width="100%"
                                        autocomplete
                                    >
                                    <vs-select-item v-for="(item, index) in stocktypesOption" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
							    </div>
							</div>

			      		</div>
			      		<div class="vx-col md:w-1/3">
						    <div class="vx-row mb-3">
							    <div class="vx-col w-full">
							       <vs-input class="w-full" label="Open Qty" v-model="check.out_standing_base_qty" :disabled="true"/>
							    </div>
							</div>
			      			<div class="vx-row mb-3">
							    <div class="vx-col w-full">
							      	<label for="" class="vs-input--label">Remarks</label>
							      	<vs-textarea v-model="check.remark" />
							    </div>
							</div>
						    <p class="my-4 text-right">
						    	<vs-button class="mr-2" color="primary" @click="ScanItem">Save</vs-button>
						    </p>
			      		</div>
			      	</div>
        		</vs-tab>
				<vs-tab label="Checked Items">
                	<div class="flex flex-wrap items-center justify-between my-6">
		                <div class="flex items-right">
			         		 <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="cancelCheck">Cancel Check</vs-button>
		           		</div>
	                </div>
                  <vs-table stripe multiple :data="item_checked" v-model="selectedCheckedItem">
						      <template slot="thead">
						        <vs-th>Product</vs-th>
						        <vs-th>Description</vs-th>
						        <vs-th>Pack ID</vs-th>
						        <vs-th>Batch</vs-th>
						        <vs-th>Exp. Date</vs-th>
						        <vs-th>Qty</vs-th>
						        <vs-th>UoM</vs-th>
						        <vs-th>Stock Type</vs-th>
						        <vs-th>Base Qty</vs-th>
						        <vs-th>Base UoM</vs-th>
						      </template>

						      <template slot-scope="{data}">
						        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
						          <vs-td>
						            {{data[indextr].product_code}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].description}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].pack_id}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].batch}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].expired_date}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].uom_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].stock_type_name}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].checked_item_base_qty}}
						          </vs-td>

						          <vs-td>
						            {{data[indextr].base_uom_name}}
						          </vs-td>


						        </vs-tr>
						      </template>
					    </vs-table>
					</vs-tab>
        	</vs-tabs>

    	</vs-popup>

	</div>
 </div>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import { AgGridVue } from "ag-grid-vue"
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	import '@/assets/scss/vuesax/_wmsTheme.scss';

	export default {
		name:"inb-create",
		components:{
			vSelect,
			flatPickr,
			AgGridVue,
		},
		data(){
			return {
				checkPopup: false,
				gr_id: '',
				gr_reference: '',
				gr_status: '',
				client_doc: false,
				client_type: '',
				gr_details: [],
				gr_details_selected: [],
				gr_checked: [],
				gr_checked_selected: [],
				item_outstanding: {},
				item_checked: [],
				isLoading: false,
				showPopup: false,
				check: {
					product_code: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					uom_id: '',
					uomOption: [],
					qty: '',
					stock_type_id: this.$store.state.user.userconfig.stock_type_id,
					out_standing_base_qty: '',
					remark: ''
				},
				batchCheck: {
					product_code: '',
					description: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					uom: '',
					qty: 1,
					stock_type: 'AV',
					remark: ''
				},
				documentCheck: {
					product_code: '',
					description: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					uom: '',
					qty: 1,
					stock_type: 'AV',
					remark: ''
				},
				stocktypesOption: [],
                selectedCheckedItem: [],
                lastScanned: {
                    product_code: "",
                    description: "",
                    qty: "",
                    pack_id: ""
                },
                currentProduct: {
                    product_code: "",
                    description: "",
                    base_uom: "",
                    outstanding_qty: ''
                },
				lastScannedDoc: {
                    product_code: "",
                    description: "",
                    qty: "",
                    pack_id: ""
                },
				currentProductDoc: {
                    product_code: "",
                    description: "",
                    base_uom: "",
                    outstanding_qty: ''
                },
			}
		},
	watch:{
	    isLoading: function(){
	        if(this.isLoading){
	            this.$vs.loading()
	        }
	        else{
	            this.$vs.loading.close()
	        }
	    },
	},
    beforeMount() {
    	this.popUpCheck = false ;
        if(this.isLoading){
            this.$vs.loading()
        }
    },
	methods:{
		refresh() {
			this.$http.get('inbound/checkgoodreceive/' + this.$route.params.id + '/showall')
			.then(res => {
				this.isLoading = false
				this.gr_id = res.data.good_receive.gr_id
				this.gr_reference = res.data.good_receive.gr_reference
				this.gr_status = res.data.good_receive.name
				this.client_type = res.data.good_receive.client_type

				if(res.data.good_receive.client_type === 'DOCUMENT'){
					this.client_doc = false
				}

				this.gr_checked = res.data.checked_items

				this.gr_details = res.data.out_standing.map(item => {
					let uoms = item.product_uoms.map(uom => {
						return {
							id: uom.uom.id,
							name: uom.uom.name
						}
					})

					return {
						gr_details_id: item.id,
						product_code: item.product_code,
						description: item.description,
						pack_id: item.pack_id,
						batch: item.batch,
						expired_date: item.expired_date,
						qty: item.out_standing_qty,
						uom_id: item.uom_id,
						uom_options: uoms,
						stock_type_id: item.stock_type_id,
						base_qty: item.out_standing_base_qty,
						base_uom_name: item.base_uom_name
					}
				})

				this.gr_details_selected = []

			})
			.catch(error => {
				this.isLoading = false
				console.log(error)
			})
		},
		storeAll() {
			const data = this.gr_details_selected.map(item => {
				return {
					gr_details_id: item.gr_details_id,
					pack_id: item.pack_id,
					batch: item.batch,
					expired_date: item.expired_date,
					checked_item_qty: item.qty,
					uom_id: item.uom_id,
					stock_type_id: item.stock_type_id,
					client_type: this.client_type
				}
			})

			if(data.length < 1) {
				this.$vs.notify({
					color: 'danger',
					title: 'Error',
					text: 'No data selected.',
				});
				return false
			}

			this.isLoading = true

			this.$http.post('inbound/checkgoodreceive/storeall', {'list_item_checks': JSON.stringify(data)})
			.then(res => {
				console.log(res)
				this.isLoading = false
				this.gr_status = res.data.good_receive.name
				this.check.out_standing_base_qty = res.data.out_standing.out_standing_base_qty
				this.item_checked = res.data.checked_items
				this.gr_checked = res.data.checked_items
				this.gr_details_selected = []

				this.gr_details = res.data.out_standing.map(item => {
					let uoms = item.product_uoms.map(uom => {
						return {
							id: uom.uom.id,
							name: uom.uom.name
						}
					})

					return {
						gr_details_id: item.id,
						product_code: item.product_code,
						description: item.description,
						pack_id: item.pack_id,
						batch: item.batch,
						expired_date: item.expired_date,
						qty: item.out_standing_qty,
						uom_id: item.uom_id,
						uom_options: uoms,
						stock_type_id: item.stock_type_id,
						base_qty: item.out_standing_base_qty,
						base_uom_name: item.base_uom_name
					}
				})

				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Check Item Succesfully',
				});
			})
			.catch(error => {
				this.isLoading = false
				if(error.response.data) {
					error.response.data.message.map(item => {
						this.$vs.notify({
							color: 'danger',
							title: 'Error',
							text: item,
						});
					})
				}
				else {
					this.$vs.notify({
						color: 'danger',
						title: 'Error',
						text: 'Something went wrong.',
					});
				}
			})
		},
		cancelAll() {
			const id = this.gr_checked_selected.map(item => {
				return item.id
			})

			if(id.length < 1) {
				this.$vs.notify({
					color: 'danger',
					title: 'Error',
					text: 'No data selected.',
				});
				return false
			}

			this.isLoading = true

			this.$http.post('inbound/checkgoodreceive/destroyall', {id: id})
			.then(res => {
				this.isLoading = false
				this.gr_checked_selected = []
				this.gr_status = res.data.good_receive.name
				this.check.out_standing_base_qty = res.data.out_standing.out_standing_base_qty
				this.item_checked = res.data.checked_items
				this.gr_checked = res.data.checked_items

				this.gr_details = res.data.out_standing.map(item => {
					let uoms = item.product_uoms.map(uom => {
						return {
							id: uom.uom.id,
							name: uom.uom.name
						}
					})

					return {
						gr_details_id: item.id,
						product_code: item.product_code,
						description: item.description,
						pack_id: item.pack_id,
						batch: item.batch,
						expired_date: item.expired_date,
						qty: item.out_standing_qty,
						uom_id: item.uom_id,
						uom_options: uoms,
						stock_type_id: item.stock_type_id,
						base_qty: item.out_standing_base_qty,
						base_uom_name: item.base_uom_name
					}
				})

				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Cancel Check Succesfully',
				});
			})
			.catch(error => {
				this.isLoading = false
				const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
				this.$vs.notify({
					color: 'danger',
					title: 'Error',
					text: message,
				});
			})
		},
	viewProduct(product, index){
		this.isLoading = true
		this.$http.get('inbound/checkgoodreceive/' + product.gr_details_id + '/show')
		.then(res => {
			this.check = {
				product_code: '',
				pack_id: '',
				batch: '',
				expired_date: '',
				uom_id: '',
				uomOption: [],
				qty: '',
				stock_type_id: this.$store.state.user.userconfig.stock_type_id,
				out_standing_base_qty: '',
				remark: ''
			}

			this.isLoading = false
			this.item_outstanding = res.data.out_standing
			this.item_checked = res.data.checked_items
			this.showPopup = true
			this.check.product_code = res.data.out_standing.product_code
			this.check.out_standing_base_qty = res.data.out_standing.out_standing_base_qty
			this.check.qty = res.data.label_type == 'UID' ? 1 : ''
			this.check.uomOption = res.data.out_standing.product_uoms.map(uom => {
				return {
					value: uom.uom.id,
					text: uom.uom.name
				}
			})
			this.check.uom_id = res.data.out_standing.uom_id
		})
		.catch(error => {
			console.log(error)
			this.isLoading = false
		})
	},
	cancelCheck(){
			const id = this.selectedCheckedItem.map(item => {
				return item.id
			})

			if(id.length < 1) {
				this.$vs.notify({
					color: 'danger',
					title: 'Error',
					text: 'No data selected.',
				});
				return false
			}

			this.isLoading = true

			this.$http.post('inbound/checkgoodreceive/destroy', {id: id})
			.then(res => {

				this.isLoading = false
				this.selectedCheckedItem = []
				this.check.out_standing_base_qty = res.data.out_standing.out_standing_base_qty
				this.item_checked = res.data.checked_items
				this.gr_status = res.data.good_receive.name

				this.gr_details.map(item => {
					if(item.gr_details_id == res.data.out_standing.id) {
						item.qty = res.data.out_standing.out_standing_qty
						item.base_qty = res.data.out_standing.out_standing_base_qty
					}
				})

				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Cancel Check Succesfully',
				});
				this.refresh()
			})
			.catch(error => {
				this.isLoading = false
				console.log(error)
			})
		},
		getCheckingProduct() {
            this.isLoading = true;
            this.currentProduct.product_code = '';
			this.$http.post('inbound/checkgoodreceive/getcheckingproduct', { gr_id: this.$route.params.id, product_code: this.batchCheck.product_code })
			.then(res => {
				this.isLoading = false;
				this.batchCheck.product_code = res.data.product_code
				this.batchCheck.uom = res.data.uom
                this.batchCheck.description = res.data.description

                this.currentProduct.product_code = res.data.product_code
                this.currentProduct.description = res.data.description
                this.currentProduct.base_uom = res.data.uom
                this.currentProduct.outstanding_qty = `${res.data.outstanding_qty} ${res.data.uom}`

                this.batchCheck.out_standing_base_qty = res.data.outstanding_qty;
                this.focusInput('pack_id', true)
			})
			.catch(error => {
				this.batchCheck.product_code = ''
				this.handleError(error)
			})
		},
		getCheckingProductDoc() {
            this.isLoading = true;
            this.currentProductDoc.product_code = '';
			this.$http.post('inbound/checkgoodreceive/getcheckingproduct', { gr_id: this.$route.params.id, product_code: this.documentCheck.product_code })
			.then(res => {
				this.isLoading = false;
				this.documentCheck.product_code = res.data.product_code
				this.documentCheck.uom = res.data.uom
                this.documentCheck.description = res.data.description

                this.currentProductDoc.product_code = res.data.product_code
                this.currentProductDoc.description = res.data.description
                this.currentProductDoc.base_uom = res.data.uom
                this.currentProductDoc.outstanding_qty = `${res.data.outstanding_qty} ${res.data.uom}`

                this.documentCheck.out_standing_base_qty = res.data.outstanding_qty;
                this.focusInput('pack_id', true)
			})
			.catch(error => {
				this.documentCheck.product_code = ''
				this.handleError(error)
			})
		},
		submitItemCheck() {
			// this.isLoading = true
			console.log('asd')
		},
		ScanItem(){
			const data = {
				gr_details_id: this.item_outstanding.id,
				pack_id: this.check.pack_id,
				batch: this.check.batch,
				expired_date: this.check.expired_date,
				checked_item_qty: this.check.qty,
				uom_id: this.check.uom_id,
				stock_type_id: this.check.stock_type_id,
				remark: this.check.remark,
				client_type : this.client_type
			}

			this.isLoading = true

			this.$http.post('inbound/checkgoodreceive/store', data)
			.then(res => {
				const oldCheck = this.gr_checked
				this.isLoading = false
				this.check.out_standing_base_qty = res.data.out_standing.out_standing_base_qty
				this.item_checked = res.data.checked_items
				this.gr_status = res.data.good_receive.name

				this.gr_details.map(item => {
					if(item.gr_details_id == res.data.out_standing.id) {
						item.qty = res.data.out_standing.out_standing_qty
						item.base_qty = res.data.out_standing.out_standing_base_qty
					}
				})

				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Check Item Succesfully',
				});

				this.refresh()
			})
			.catch(error => {
				this.isLoading = false
				if(error.response.data) {
					error.response.data.message.map(item => {
						this.$vs.notify({
							color: 'danger',
							title: 'Error',
							text: item,
						});
					})
				}
				else {
					this.$vs.notify({
						color: 'danger',
						title: 'Error',
						text: 'Something went wrong.',
					});
				}
			})

			// this.$vs.notify({
            //     color: 'success',
            //     title: 'Check Item Succesfully',
            //     text: 'Product "'+obj.product_code+'" Checked',
            // });

			// 	this.$vs.notify({
            //     color: 'warning',
            //     title: 'Check Item Failed',
            //     text: 'No product need to check ',
            // 	});

		},
		setSelectedProduct() {
	    	if(this.check.product_id != null){
	    	this.isLoading = true ;
			this.$http.get('/master/product/'+this.check.product_id)
			  .then((response) =>  {
			  	let prd = response.data;
		          this.check.uomOption = [];
		          this.check.baseUomOption = [];
		          // for(let i = 0; i < prd.uoms.length; i++){
		          //     this.uomOption.push({...prd.uoms[i].uom, label:prd.uoms[i].uom.name,});
		          // }
		              // console.log("base_uom : "+JSON.stringify(prd.default_uom.uom.name));
		          	  // this.check.uomOption = prd.uoms;
		          	  prd.uoms.map(item => {
                            this.check.uomOption.push(item.uom);
                      })
		              this.check.label_type = prd.product.productcategories.label_type ;

		              if(prd.product.productcategories.label_type == 'UID'){
		              	this.check.qty = 1;
		              	this.check.base_qty = 1;
		              }else{
	    			  	this.check.qty = this.check.product_id.qty;
		              }
		              this.check.description = prd.product.description_1;
		    		  // console.log(JSON.stringify(this.check.uomOption));
		              this.check.baseUomOption.push(prd.default_uom.uom);
		              this.check.uom_id = prd.default_uom.uom ;
		              this.check.base_uom_id = prd.default_uom.uom ;
		              this.check.stockTypeOption = this.stocktypesOption ;

		              // kurangi dengan temporari data oustanding
	    			  this.isLoading = false ;

			  })
			  .catch(function (error) {
			    console.log(error);
			  });
	    	}
	    	else{
	    		 this.check.uom = null;
	    		 this.check.uomOption = [];
		         this.check.base_uom = null;
		         this.check.baseUomOption = [];
		         this.check.descriptions = '';
	    	}
		 },
		 batchScan() {
			 this.isLoading = true
			 this.$http.post('inbound/checkgoodreceive/batchscan', {
				gr_id: this.$route.params.id,
				product_code: this.batchCheck.product_code,
				pack_id: this.batchCheck.pack_id,
				batch: this.batchCheck.batch,
				expired_date: this.batchCheck.expired_date,
				uom: this.batchCheck.uom,
				qty: this.batchCheck.qty,
				stock_type: this.batchCheck.stock_type,
				remark: this.batchCheck.remark,
				client_type: this.client_type
			 })
			 .then(res => {
				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Checked successfully.'
				});

                this.isLoading = false
				this.batchCheck = {
					product_code: '',
					description: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					uom: '',
					qty: 1,
					stock_type: 'AV',
					remark: ''
                }

                this.lastScanned.product_code = res.data.last_scanned.product_code
                this.lastScanned.description = res.data.last_scanned.description
                this.lastScanned.qty = res.data.last_scanned.qty
                this.lastScanned.pack_id = res.data.last_scanned.pack_id

                this.currentProduct = {
                    product_code: "",
                    description: "",
                    base_uom: "",
                    outstanding_qty: ''
                }

                this.focusInput('product_code', true)
                this.refresh()
			 })
			 .catch(error => {
				 this.batchCheck.pack_id =''
				 this.handleError(error)
			 })
		 },
		 batchScanDoc() {
			 this.isLoading = true
			 this.$http.post('inbound/checkgoodreceive/batchscandoc', {
				gr_id: this.$route.params.id,
				product_code: this.documentCheck.product_code,
				pack_id: this.documentCheck.pack_id,
				batch: this.documentCheck.batch,
				expired_date: this.documentCheck.expired_date,
				uom: this.documentCheck.uom,
				qty: this.documentCheck.qty,
				stock_type: this.documentCheck.stock_type,
				remark: this.documentCheck.remark
			 })
			 .then(res => {
				this.$vs.notify({
					color: 'success',
					title: 'Success',
					text: 'Checked successfully.'
				});

                this.isLoading = false

				this.documentCheck.pack_id = ''
				this.documentCheck.batch = ''
				this.documentCheck.expired_date = ''
				this.documentCheck.qty = 1
				this.documentCheck.stock_type = 'AV'
				this.documentCheck.remark = ''

                this.lastScannedDoc.product_code = res.data.last_scanned.product_code
                this.lastScannedDoc.description = res.data.last_scanned.description
                this.lastScannedDoc.qty = res.data.last_scanned.qty
                this.lastScannedDoc.pack_id = res.data.last_scanned.pack_id

                this.currentProductDoc = {
                    product_code: "",
                    description: "",
                    base_uom: "",
                    outstanding_qty: ''
                }

				this.$refs.remark_doc.focus();

                //this.focusInput('remark_doc', true)
                this.refresh()
			 })
			 .catch(error => {
				 this.documentCheck.pack_id =''
				 this.handleError(error)
			 })
		 },
		validationDetail(data){

            if(this.data_conv > (data.old_recv_qty + data.old_open_qty)){
              data.errText = 'qty cant higher than open qty';
              data.err = true;
              data.qty = 0 ;
              data.open_qty = data.old_open_qty ;
              data.base_qty = data.old_base_qty ;
              data.uom_id = data.old_uom_id;
              console.log('here 1');
            }
            else{
              var sisa = data.old_open_qty - this.data_conv
              if(sisa < 0 && data.old_open_qty != 0){
  	              data.errText = 'qty cant lower than open qty';
	              data.err = true;
	              // data.qty = data.old_open_qty ;
	              data.open_qty = 0 ;
	              console.log('here 2');
	              data.base_qty = data.old_base_qty ;
	              data.uom_id = data.old_uom_id;
              }else{
	              data.open_qty = sisa ;
	              data.base_qty = this.data_conv ;
	              console.log('here 3');
	              data.errText = '';
	              data.err = false;
              }
            }
            console.log("old uom id : "+data.old_uom_id);

        },
	    Conversion : function(data){
	    	 data.base_qty = (data.qty / data.denominator) * data.numerator
	    },
		onChangeUom(data){
    	  this.check.uomOption.map(item => {
                if(item.id == this.check.uom_id){
                	this.check.numerator = item.numerator
                	this.check.denominator = item.denominator
                	this.check.uom_name = item.name
			    	  // console.log('rpt : uom');
			    	  // console.log(item);
                }
          })
          this.Conversion(data)
	  	},
		removeItem(index){
    	    this.$vs.dialog({
		        type: 'confirm',
		        color: 'warning',
		        title: `Warning`,
		        text: 'Are you sure want to delete this Product ?',
		        accept: () => {
        		  	if(this.OutstandingItems[index].status == 'insert'){
            			this.OutstandingItems.splice(index, 1);
		        	}else{
		        		this.OutstandingItems[index].status = 'delete';
		        	}
		        }
		     })
        },
		disabledFullyRecv(data){
			if(data.recv_qty != 0 && data.open_qty == 0 && data.recv_qty == data.base_qty && this.inbound_status.id > 1){
				return true;
			}else{
				return false;
			}
		},
		cancelAndBack(){
			this.$router.push({
				name: 'good-receive-view',
				params: {
					id: this.$route.params.id,
				}
			})
		},
	    generateLineId(){
	    	let max_line = 0;
	    	if(this.OutstandingItems.length > 0){
	    	   this.OutstandingItems.map(item => {
	               var tmp = parseInt(item.line_id);
	               if (tmp > max_line){
	                 max_line = tmp;
	               }
	    	   });
	    	}else{
	    		return 1 ;
	    	}
	    	return max_line+=1;
		},
		checkInit() {
			this.batchCheck = {
				product_code: '',
				description: '',
				pack_id: '',
				batch: '',
				expired_date: '',
				uom: '',
				qty: 1,
				stock_type: 'AV',
				remark: ''
			}

			this.documentCheck = {
				product_code: '',
				description: '',
				pack_id: '',
				batch: '',
				expired_date: '',
				uom: '',
				qty: 1,
				stock_type: 'AV',
				remark: ''
			}
            this.focusInput('product_code', true)
			this.checkPopup = true;
		},
     	saveItemCheck(){
     		this.isLoading = true;

	       	 let data_details = [];
  	         this.checkedItemsDelete.map(item => {
	            let obj = {};
	            obj = {
		            id: item.id,
		            gr_details_id:item.gr_details_id,
		            product_id: item.product_id.id,
		            pack_id: item.pack_id,
		            batch: item.batch,
		            expired_date: item.expired_date,
		            uom_id: item.uom_id,
		            checked_item_qty: item.checked_item_qty,
		            stock_type_id: item.stock_type_id,
		            checked_item_base_qty: item.checked_item_base_qty,
		            base_uom_id: item.base_uom_id,
		            remark: item.remark,
		            status: 'delete',
	  				};
  				data_details.push(obj);
	         });

	         this.checkedItemsInsert.map(item => {
	            let obj = {};
	             	obj = {
		            gr_details_id: item.gr_details_id,
		            product_id: item.product_id.id,
		            pack_id: item.pack_id,
		            batch: item.batch,
		            expired_date: item.expired_date,
		            uom_id: item.uom_id,
		            checked_item_qty: item.qty,
		            stock_type_id: item.stock_type_id,
		            checked_item_base_qty: item.qty,
		            base_uom_id: item.base_uom_id,
		            remark: item.remark,
		            status: 'insert',
	  				};
	  			data_details.push(obj);
	         });


	       let data_send = {
	        // good_receive : JSON.stringify(inbound_head),
	        list_item_checks : JSON.stringify(data_details),
	        // inbound_delivery_custom :JSON.stringify(inbound_detail_custom),
	       };
	        this.$http.post(`/inbound/checkgoodreceive/store`,data_send)
	        .then((resp) => {
	           // let rstr = JSON.stringify(resp.data);
     			this.isLoading = false;

	             this.$vs.notify({
	                color: 'success',
	                title: 'Check Succes',
	                text: 'Item Check Succesfully'
	              });
	             this.$router.push({
			          name: 'good-receive-view',
			          params: {
			              id: this.inbound_id,
			              on_edit: true,
			          }
			      });
	        })
	        .catch((error) =>{
     	     this.isLoading = false;
     	     const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
	         this.$vs.notify({
		        color: 'danger',
		        title: 'Error',
		        text: message
		      });
	          this.err = message;
	        });


     	},
     	// generatedDataOutstanding(){

     	// 	this.isLoading = true ;

		    // function getProductbyId(ax, id) {
	     //      return ax.get('master/product/'+id);
	     //    }
	     //    function getStockType(ax) {
	     //      return ax.get('/master/stocktypes');
	     //    }

	     //   this.OutstandingItems = [];
	     //   this.productOption = [];
	     //   this.oustandingCount = [];

	     //   this.DataOutstanding.map(item => {
	     //        this.$http.all([getProductbyId(this.$http, item.product_id), getStockType(this.$http)])
	     //        .then(this.$http.spread((singleProduct, stocktypes) => {
	     //        	let data_uom = [] ;
	     //        	singleProduct.data.uoms.map(uoms => {
	     //        		data_uom.push(uoms.uom);
	     //        	});
	     //        	this.stocktypesOption = stocktypes.data ;
	     //        	if(item.label_type == 'SKU'){
	     //        		this.OutstandingItems.push({
	     //        			...item,
	     //        			line_id:this.generateLineId(),
	     //        			status: item.status == 'delete' ? 'delete' : 'insert',
	     //        			description: item.description,
	     //        			product_id:{id :item.product_id, product_code:item.product_code},
	     //        			qty:item.out_standing_qty,
	     //        			old_qty:item.out_standing_qty,
	     //        			open_qty:0,
	     //        			old_open_qty:item.out_standing_qty,
	     //        			base_qty:item.out_standing_base_qty,
	     //        			old_base_qty:item.out_standing_base_qty,
	     //        			old_uom_id:item.uom_id,
	     //        			// old_recv_qty:item.recv_qty,
	     //        			// productOption:[item.inbound_details.product],
	     //        			uomOption:data_uom,
	     //        			baseUomOption:[{id:item.base_uom_id, name:item.base_uom_name, }],
	     //        			stockTypeOption:stocktypes.data,
		    //         	});

	     //        		this.oustandingCount.push(1);

	     //        	}else{
	     //        		// for(let i = 0 ; i < item.out_standing_qty; i++){
	     //        			this.OutstandingItems.push({
	     //        			...item,
	     //        			line_id:this.generateLineId(),
	     //        			status: item.status == 'delete' ? 'delete' : 'insert',
	     //        			description: item.description,
	     //        			product_id:{id :item.product_id, product_code:item.product_code},
	     //        			qty:1,
	     //        			old_qty:1,
	     //        			open_qty:0,
	     //        			old_open_qty:1,
	     //        			base_qty:1,
	     //        			old_base_qty:1,
	     //        			out_standing_qty:1,
	     //        			out_standing_base_qty:1,
	     //        			// old_recv_qty:item.recv_qty,
	     //        			// productOption:[item.inbound_details.product],
	     //        			old_uom_id:item.uom_id,
	     //        			uomOption:data_uom,
	     //        			baseUomOption:[{id:item.base_uom_id, name:item.base_uom_name}],
	     //        			stockTypeOption:stocktypes.data,
		    //         	});
	     //        			this.oustandingCount.push(1);
	     //        		// }
	     //        	}

    		//         if(item.out_standing_qty > 0){
	     //        	this.productOption.push({
      //       				id:item.product_id, product_code:item.product_code,
      //       				gr_details_id:item.id,
	     //        			description: item.description,
	     //        			product_id:{id :item.product_id, product_code:item.product_code},
	     //        			qty:item.out_standing_qty,
	     //        			old_qty:item.out_standing_qty,
	     //        			open_qty:item.out_standing_qty,
	     //        			old_open_qty:item.out_standing_qty,
	     //        			base_qty:item.out_standing_base_qty,
	     //        			old_base_qty:item.out_standing_base_qty,
	     //        			old_uom_id:item.uom_id,
	     //        			// old_recv_qty:item.recv_qty,
	     //        			// productOption:[item.inbound_details.product],
	     //        			uomOption:data_uom,
	     //        			baseUomOption:[{id:item.base_uom_id, name:item.base_uom_name}],
	     //        			stockTypeOption:stocktypes.data,
      //       			});
	     //    		}

	     //    		if(this.oustandingCount.length == this.OutstandingItems.length){
	     // 				this.isLoading = false ;
	     //    		}


	     //        }))
      //       });

     	// },
	},
    mounted(){
    	if(this.$route.params.id != undefined){
			this.isLoading = true;
			Promise.all([this.$http.get('inbound/checkgoodreceive/' + this.$route.params.id + '/showall'), this.$http.post('master/stocktypes')])
			.then(this.$http.spread((res, stock_type) => {
				this.isLoading = false
				this.gr_id = res.data.good_receive.gr_id
				this.gr_reference = res.data.good_receive.gr_reference
				this.gr_status = res.data.good_receive.name
				this.client_type = res.data.good_receive.client_type

				if(res.data.good_receive.client_type === 'DOCUMENT'){
					this.client_doc = true
				}

				this.stocktypesOption = stock_type.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})

				this.gr_checked = res.data.checked_items

				this.gr_details = res.data.out_standing.map(item => {
					let uoms = item.product_uoms.map(uom => {
						return {
							id: uom.uom.id,
							name: uom.uom.name
						}
					})

					return {
						gr_details_id: item.id,
						product_code: item.product_code,
						description: item.description,
						pack_id: item.pack_id,
						batch: item.batch,
						expired_date: item.expired_date,
						qty: item.out_standing_qty,
						uom_id: item.uom_id,
						uom_options: uoms,
						stock_type_id: item.stock_type_id,
						stock_type_name: item.stock_type_name,
						base_qty: item.out_standing_base_qty,
						base_uom_name: item.base_uom_name
					}
				})

				this.gr_details_selected = this.gr_details

			}))
			.catch(error => {
                this.handleError(error)
                this.$router.push({
                    name: 'good-receive-view',
                    params: {
                        id: this.$route.params.id
                    }
                })
			})
    	}else{
    		this.$router.replace('/good-receive');
    	}
    },
	}
</script>

